export enum LegalDocumentType {
  PRIVACY_POLICY = 'privacy-policy',
  TERMS_OF_USE = 'terms-of-use',
  COOKIE_NOTICE = 'cookie-notice',
  DISPATCHER_TERMS = 'dispatcher-terms'
}
